import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import AutoBind from 'react-autobind';

import Modal from '../../util/modal';

import {
    Factura_Contado_Consultar_Transaccion, Factura_Contado_Consultar_Folio, Factura_Contado_Consultar, Factura_Consultar,
    Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey
} from '../../request/rfc';

export default class Consulta extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            transaccion: '',
            serie: '',
            folio: '',
            factura: '',
            folioUID: '',
            modalSucursal: '',
            modalFolio: '',
            showModal: false,
            disabled: false
        };
        AutoBind(this);
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onXML() {
        const { modalSucursal, modalFolio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: modalSucursal, pFolio: modalFolio })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onPDF() {
        const { modalSucursal, folioUID } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: modalSucursal, pFolio: folioUID })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', Data.Nombre);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });


    }

    onCloseModal() {
        this.setState({ showModal: false });
    }

    onConsultarTransaccion() {
        const { transaccion } = this.state;
        if (transaccion === '') {
            alert('Debe ingresar un valor en la transacción para poder realizar la consulta');
            return;
        } else {
            this.setState({ disabled: true });
            Factura_Contado_Consultar_Transaccion({ pTransaccion: transaccion })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        this.setState({
                            modalSucursal: Data.Suc_Id, modalFolio: Data.NumeroFactura,
                            showModal: true, disabled: false, folioUID: Data.UUID
                        });
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        }
    }

    onConsultarFolio() {
        const { folio, serie } = this.state;
        if (folio === '' || serie === '') {
            alert('Debe ingresar los valores de Serie y Número de Folio para poder realizar la consulta.');
            return;
        } else {
            this.setState({ disabled: true });
            Factura_Contado_Consultar_Folio({ pSerie: serie, pFolio: folio })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        if (Data.Exitoso) {
                            this.setState({
                                modalSucursal: Data.Suc_Id, modalFolio: folio, showModal: true,
                                disabled: false, folioUID: Data.UUID
                            });
                        }
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        }
    }

    onConsultarNotaCredito() {
        const { sucursalNC, cajaNC, facturaNC } = this.state;
        if (sucursalNC === '' || cajaNC === '' || facturaNC === '') {
            alert('Debe ingresar los valores de Sucursal, Caja y Número Factura de la Nota de Credito para poder realizar la consulta.');
            return;
        } else {
            this.setState({ disabled: true });

            Factura_Consultar({ pSucursal: sucursalNC, pCaja: cajaNC, pFactura: facturaNC, pTipoDoc_id: 3 })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        this.setState({
                            modalSucursal: Data.Suc_Id, modalFolio: Data.NumeroFactura,
                            showModal: true, disabled: false, folioUID: Data.UUID
                        });
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        }
    }

    onConsultarContado() {
        const { sucursal, caja, factura } = this.state;
        if (sucursal === '' || caja === '' || factura === '') {
            alert('Debe ingresar los valores de Sucursal, Caja y Número Factura para poder realizar la consulta.');
            return;
        } else {
            this.setState({ disabled: true });
            Factura_Contado_Consultar({ pSucursal: sucursal, pCaja: caja, pFactura: factura })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        this.setState({
                            modalSucursal: Data.Suc_Id, modalFolio: Data.NumeroFactura,
                            showModal: true, disabled: false, folioUID: Data.UUID
                        });
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        }
    }

    render() {

        const { baseUrl, serie, folio, sucursal, caja, factura, sucursalNC, cajaNC, facturaNC, transaccion, showModal, modalSucursal, modalFolio, disabled } = this.state;
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        const cssClassSpin = disabled ? 'fas fa-spinner fa-spin' : 'fas fa-search';
        return (
            <Fragment>
                <div className="row" id="consulta">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group col-md-5">
                                        <label>Serie:</label>
                                        <input type="text" className="form-control" name="serie" value={serie} placeholder="###" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-5">
                                        <label>Número Folio:</label>
                                        <input type="text" className="form-control" name="folio" value={folio} placeholder="#####" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-2">
                                        <button type="button" className="btn btn-custom-theme margin-top-30" disabled={disabled}
                                            onClick={this.onConsultarFolio}>
                                            <i className={cssClassSpin}></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group col-md-3">
                                        <label>Sucursal:</label>
                                        <input type="text" className="form-control" name="sucursal" value={sucursal} placeholder="###" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Caja:</label>
                                        <input type="text" className="form-control" name="caja" value={caja} placeholder="##" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Número Factura:</label>
                                        <input type="text" className="form-control" name="factura" value={factura} placeholder="########" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <button type="button" className="btn btn-custom-theme margin-top-30 ml-sm-3" disabled={disabled}
                                            onClick={this.onConsultarContado}>
                                            <i className={cssClassSpin}></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group col-md-3">
                                        <label>Sucursal Nota Credito:</label>
                                        <input type="text" className="form-control" name="sucursalNC" value={sucursalNC} placeholder="###" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Caja Nota Credito:</label>
                                        <input type="text" className="form-control" name="cajaNC" value={cajaNC} placeholder="##" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Número Factura Nota de Credito :</label>
                                        <input type="text" className="form-control" name="facturaNC" value={facturaNC} placeholder="########" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <button type="button" className="btn btn-custom-theme margin-top-30 ml-sm-3" disabled={disabled}
                                            onClick={this.onConsultarNotaCredito}>
                                            <i className={cssClassSpin}></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group col-md-9">
                                        <label>FOLIO A FACTURAR:</label>
                                        <input type="text" className="form-control" name="transaccion" value={transaccion} placeholder="################" readOnly={disabled}
                                            onChange={this.onChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <button type="button" className="btn btn-custom-theme margin-top-30 ml-sm-3" disabled={disabled}
                                            onClick={this.onConsultarTransaccion}>
                                            <i className={cssClassSpin}></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={showModal}
                    serie={modalSucursal}
                    folio={modalFolio}
                    onXML={this.onXML}
                    onPDF={this.onPDF}
                    onCloseModal={this.onCloseModal}
                />
            </Fragment>
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/consulta/index.jsx